import React from "react";
import { Carousel } from "antd";

import FeatureCard from "./FeatureCard";
import styles from "../LandingPage.module.scss";

const agrupar = (lista, tamanho) => {
    const grupos = [];
    for (let i = 0; i < lista.length; i += tamanho) grupos.push(lista.slice(i, i + tamanho));
    return grupos;
};

const renderCards = cards => cards.map(card => <FeatureCard key={card.titulo} {...card} />);

const renderCarousel = (cards, porSlide) => (
    <Carousel autoplay>
        {agrupar(cards, porSlide).map(grupo => (
            <div key={grupo[0].titulo} className={styles.cardsListCarousel}>
                {renderCards(grupo)}
            </div>
        ))}
    </Carousel>
);

const FeatureCards = ({ cards, className }) => (
    <div className={`${styles.homeCards} ${className}`}>
        <div className={`${styles.cardsList} ${styles.cardsListDesktop}`}>{renderCards(cards)}</div>
        <div className={`${styles.cardsList} ${styles.cardsListTablet}`}>{renderCarousel(cards, 2)}</div>
        <div className={`${styles.cardsList} ${styles.cardsListMobile}`}>{renderCarousel(cards, 1)}</div>
    </div>
);

export default FeatureCards;
